export function useHistoricalReportData(rowData) {
  // Destructuring rowData to extract specific details for display
  let {
    _id,
    id,
    qualityReportsID,
    itemERPCode,
    itemDescription,

    requestDate,
    name,
    brand,
    countryOfOrigin,
    expiryDate,

    purpose,
    requestingDepartment,
    SCL,
    fileName,
    fullPath,
    chefEmail,
    historicalReport,
    numOfSamples,
    packing,
    packagingType,
    prodDate,
    sampleSubmitDate,
    mainFolder,
    subFolder,
    ...rowRest
  } = rowData;

  // Grouping data into sections for display
  let ids = {
    qualityReportsID,
    requestDate,
    requestedBy: chefEmail,
    purpose,
    requestingDepartment,
    SCL,
  };
  let itemDetails = {
    itemERPCode,
    itemDescription,
    preferredUnitOfMeasure: packing,
    quantityForSample: numOfSamples,
  };

  let sampleDetails = {
    supplierName: name,
    brand,
    countryOfOrigin,
    packaging: packagingType,
    receiptDate: sampleSubmitDate,
    productionDate: prodDate,
    expiryDate,
    ...rowRest,
  };

  let dataGroups = [
    { title: "Item Details", data: itemDetails },
    { title: "Sample Details", data: sampleDetails },
  ];

  return {
    ids,
    dataGroups,
    fullPath,
  };
}
